import { render, staticRenderFns } from "./ProfileFormDialog.vue?vue&type=template&id=b68e13b6"
import script from "./ProfileFormDialog.vue?vue&type=script&lang=js"
export * from "./ProfileFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports